import styled, {css} from 'styled-components'

export const StyledTabsBar = styled.div`
    ${({theme}) => css`
        display: flex;
        gap: ${theme.spacing}px;
        padding: 0 ${theme.spacing * 6}px;
        border-bottom: 1px solid ${theme.palette.neutral['200']};
    `}
`

export const StyledTabButton = styled.button<{$active: boolean}>`
    ${({theme, $active}) => css`
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing * 2}px;
        padding: ${theme.spacing * 3}px ${theme.spacing * 4}px;
        margin-bottom: -1px;
        ${theme.typography.textSm};
        font-weight: 500;
        background: transparent;
        border: none;
        border-bottom: 2px solid ${$active ? theme.palette.primary['600'] : 'transparent'};
        color: ${$active ? theme.palette.primary['600'] : theme.palette.neutral['500']};
        cursor: pointer;
        transition: ${theme.transition};

        &:hover {
            color: ${$active ? theme.palette.primary['600'] : theme.palette.neutral['700']};
        }

        & svg {
            width: 16px;
            height: 16px;
        }
    `}
`
